<script lang="ts" setup>
import { BuyerNotificationQuery } from '@gql/BuyerNotificationQuery'

const t2 = useT2({
  'Notify Me': 'Pranešimai',
})

const props = defineProps<{
  notify: ReturnType<typeof useNotify>
  inStock: boolean
  productPrice: number
  productId: string
}>()

const { ui: doc } = useApolloWrap2<gen.BuyerNotificationQuery, gen.BuyerNotificationQueryVariables>(BuyerNotificationQuery)({
  clientId: 'post',
  ui: (i) => i?.buyerNotification,
  vars: () => ({ input: { _id: props.productId } }),
})
</script>

<template>
  <div class="_pl14 _pr14 _pb2">
    <UiUpper :title="t2('Notify Me')" line><IconBell class="_svg16" /></UiUpper>
  </div>
  <BuyerNotifyForm :notify :in-stock :product-price :doc :product-id view="product" pad />
</template>
